import { normalizeError } from '../api/core/errors';
import { msg, type Msg } from '../i18n/msg.ts';

/** The teacher-facing wording for a failed request, as a Msg: store it, translate at render (useMsg). */
export function userError(error: unknown): Msg {
  const normalized = normalizeError(error);

  switch (normalized.kind) {
    case 'network':
      return msg('errors:userError.network');
    case 'timeout':
      return msg('errors:userError.timeout');
    case 'unauthorized':
      return msg('errors:userError.unauthorized');
    case 'forbidden':
      return msg('errors:userError.forbidden');
    case 'notFound':
      return msg('errors:userError.notFound');
    case 'validation':
      return msg('errors:userError.validation');
    case 'canceled':
      return msg('errors:userError.canceled');
    case 'server':
      return msg('errors:userError.server');
    default:
      return msg('errors:userError.fallback');
  }
}
